import { OrderRejectionReason } from '../../../../../../../services/exports/Constants';

export default {
  statuses: {
    rejected: 'Anulată: {{reason}}',
    fulfilled: 'Această comandă a fost finalizată cu succes',
  },
  rejection_reasons: {
    [OrderRejectionReason.Automatic]: 'Neacceptată',
    [OrderRejectionReason.ClosingSoon]: 'Se închide curând',
    [OrderRejectionReason.ItemUnavailable]: 'Articol indisponibil',
    [OrderRejectionReason.OrderTooBig]: 'Comandă prea mare',
    [OrderRejectionReason.CustomerMistake]: 'Greșeală client',
    [OrderRejectionReason.Other]: 'Altele',
    fully_refunded: 'Comanda a fost integral rambursată',
  },
};
